import React from 'react';
import { Link } from 'react-router-dom';

const CookiePolicy = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-50 dark:from-gray-950 dark:via-gray-900 dark:to-gray-950">
      <div className="max-w-4xl mx-auto px-4 py-16">
        {/* Header */}
        <div className="text-center mb-12 animate-fade-in">
          <h1 className="text-5xl font-bold mb-4 bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 dark:from-white dark:via-gray-100 dark:to-white bg-clip-text text-transparent tracking-tight">
            Cookie Policy
          </h1>
          <p className="text-xl text-gray-600 dark:text-gray-400 font-light tracking-wide">
            How we use cookies and similar technologies
          </p>
        </div>

        <div className="space-y-6">
          <div className="premium-card p-8">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              What Are Cookies?
            </h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
              Cookies are small text files that are stored on your device when you visit a website. 
              They help websites remember your preferences and improve your browsing experience.
            </p>
          </div>

          <div className="premium-card p-8">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              Our Cookie Usage
            </h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
              The AI Grading Agent uses minimal cookies and local storage:
            </p>
            <ul className="space-y-3 text-gray-700 dark:text-gray-300">
              <li className="flex gap-3">
                <span className="text-primary font-bold">•</span>
                <div>
                  <p className="font-semibold">Theme Preference</p>
                  <p className="text-sm text-gray-600 dark:text-gray-400">Stored locally to remember your light/dark mode preference</p>
                </div>
              </li>
              <li className="flex gap-3">
                <span className="text-primary font-bold">•</span>
                <div>
                  <p className="font-semibold">Settings Storage</p>
                  <p className="text-sm text-gray-600 dark:text-gray-400">Your grading settings and preferences are stored locally in your browser</p>
                </div>
              </li>
              <li className="flex gap-3">
                <span className="text-primary font-bold">•</span>
                <div>
                  <p className="font-semibold">Session Data</p>
                  <p className="text-sm text-gray-600 dark:text-gray-400">Temporary session data to maintain your login state (if password protection is enabled)</p>
                </div>
              </li>
            </ul>
          </div>

          <div className="premium-card p-8">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              Third-Party Cookies
            </h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
              We do not use third-party tracking cookies or analytics cookies. The application does not 
              include advertising networks or social media trackers that would place cookies on your device.
            </p>
          </div>

          <div className="premium-card p-8">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              Managing Cookies
            </h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
              You can control cookies through your browser settings:
            </p>
            <ul className="space-y-2 text-gray-700 dark:text-gray-300">
              <li className="flex gap-3">
                <span className="text-primary font-bold">•</span>
                <p>Most browsers allow you to refuse or delete cookies</p>
              </li>
              <li className="flex gap-3">
                <span className="text-primary font-bold">•</span>
                <p>You can set your browser to notify you when cookies are being used</p>
              </li>
              <li className="flex gap-3">
                <span className="text-primary font-bold">•</span>
                <p>Note that disabling cookies may affect the functionality of the application</p>
              </li>
            </ul>
          </div>

          <div className="premium-card p-8">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              Local Storage
            </h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
              In addition to cookies, we use browser local storage to save your preferences and settings. 
              This data remains on your device and is not transmitted to our servers. You can clear this 
              data at any time through your browser's settings.
            </p>
          </div>

          <div className="premium-card p-8">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              Updates to This Policy
            </h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-2">
              We may update this Cookie Policy from time to time. Any changes will be posted on this page 
              with an updated revision date.
            </p>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              Last updated: {new Date().toLocaleDateString()}
            </p>
          </div>

          <div className="premium-card p-8">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              Contact Us
            </h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
              If you have questions about our use of cookies, please contact us at{' '}
              <a href="mailto:privacy@aigradingagent.com" className="text-primary hover:text-primary-dark underline">
                privacy@aigradingagent.com
              </a>
            </p>
          </div>
        </div>

        {/* Back Button */}
        <div className="mt-12 text-center">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 text-gray-700 dark:text-gray-300 hover:text-primary dark:hover:text-primary-light font-medium transition-colors"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Back to App
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;
